import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class addDeskPage extends cc.Component {

    onBtnDesk() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getServices().miniGameSrv.getAppApiInstance().addShortcut().then(( resultFlag )=>{
            if ( resultFlag ) {
                O1HD.getModules().uiControlModule.showMessageBox("添加桌面成功", this.node );
                if(O1HD.getManagers().gameMgr.checkCanAddDestokAward()){
                    O1HD.getServices().userSrv.setCoins(gameConfig.ADD_DESTOK_SUCCESS_COIN,true,this.node);
                    O1HD.getManagers().gameMgr.setCanAddDestokAward();
                    O1HD.emit("normalMode.setDestokHide")
                }else{
                    O1HD.getModules().uiControlModule.showMessageBox("奖励仅限领取一次",this.node );
                }
                this.node.destroy();
                this.node.removeFromParent();
            }else{
                O1HD.getModules().uiControlModule.showMessageBox("添加桌面失败", this.node );
            }
        });
    }

    onBtnNot(){
        this.node.destroy();
        this.node.removeFromParent();
    }

}
